import { Theme, type ThemeProps } from '@chakra-ui/react'

/**
 * Forces LIGHT tokens for its subtree, even under the app's `.dark` root.
 * Used for map surfaces (design of record §5.6): the light Protomaps basemap and
 * its blue choropleth ramp are unreadable on a dark canvas, so a map's overlay
 * chrome (floating toolbar, legend, popups) stays light while the page around it
 * goes dark. Wraps Chakra v3's `<Theme appearance="light">`, whose `.chakra-theme
 * light` class re-declares the light CSS-var values for descendants — the sanctioned
 * nested-appearance escape hatch (Chakra's `_dark` condition excludes `.chakra-theme:not(.light)`).
 *
 * The MapLibre GL canvas itself is not Chakra-tokened and renders light regardless;
 * only the Chakra overlay chrome needs wrapping.
 */
export function LightSurface(props: ThemeProps) {
  return <Theme appearance="light" hasBackground={false} {...props} />
}
